import { CUSTOM_WIDGET_IN_MIGRATIONS, CUSTOM_WIDGET_MIGRATION_GATE } from './customWidgetConstants';

/**
 * Checks whether a customWidgetType is in migration to reporting-plugins
 * @param widgetType WidgetType
 * @param userInfo UserInfo
 * @returns boolean
 */
export const isUngatedForCustomWidgetMigration = (widgetType, userInfo) => {
  return CUSTOM_WIDGET_IN_MIGRATIONS.includes(widgetType) && CUSTOM_WIDGET_MIGRATION_GATE !== '' && userInfo.gates.includes(CUSTOM_WIDGET_MIGRATION_GATE);
};